export default "__VITE_ASSET__BVBuUkc2__"